<template>
  <div class="wrapper perfect-theme-design">
    <div class="content">
      <div class="title">堆箱设计配置</div>
    </div>
    <div class="content">
      <div class="title">
        <div>
          <el-button v-if="!isView" type="primary" size="mini" plain @click="handleAddRow()">新增</el-button>
        </div>
        <div :inline="true" :model="formDesign" class="demo-form-inline">
          <el-input class="iptSize" size="mini" v-model="formDesign.defineName" clearable placeholder="堆箱名称" style="width:120px;"></el-input>
          <el-select class="iptSize" size="mini" v-model="formDesign.rowColumn" clearable placeholder="堆箱规格">
            <el-option v-for="(item,index) in sizeOptions" :key="index" :label="item" :value="item"></el-option>
          </el-select>
          <el-select class="iptSize" size="mini" v-model="formDesign.stackPackSubBrands" filterable clearable placeholder="子品牌">
            <el-option v-for="item in subBrandOptions" :key="item.abiBrandId" :label="item.abiBrandName" :value="item.abiBrandCode"></el-option>
          </el-select>
          <el-button type="danger" size="mini" plain @click="onSubmit">搜索</el-button>
          <el-button type="primary" size="mini" plain @click="handleResst">重置</el-button>
        </div>
      </div>
    </div>
    <div v-if="mixPackListPagination.length">
      <div class="info">
        <el-row v-if="!isView" class="header" type="flex" align="middle" justify="center" style="margin-bottom:20px;">
          <el-col :span="2">序号</el-col>
          <el-col :span="3"><span class="require">堆箱名称</span></el-col>
          <el-col :span="6"><span class="require">堆箱规格</span></el-col>
          <el-col :span="8"><span class="require">堆箱信息</span></el-col>
          <el-col :span="5">操作</el-col>
        </el-row>
        <el-row v-else class="header" type="flex" align="middle" justify="center" style="margin-bottom:20px;">
          <el-col :span="3">序号</el-col>
          <el-col :span="5"><span>堆箱名称</span></el-col>
          <el-col :span="7"><span>堆箱规格</span></el-col>
          <el-col :span="9"><span>堆箱信息</span></el-col>
        </el-row>
        <el-row v-for="(item, index) in mixPackListPagination" :key="index" class="detail">
          <div style="display: flex; align-items: center;; justify-content: center;">
          <el-col :span="isView?3:2" style="display: flex; align-items: center;; justify-content: center;">{{item.sequenceFlag}}</el-col>
          <el-col :span="isView?5:3" style="display: flex; align-items: center;">
            <el-tooltip effect="light" :content="item.defineName" placement="top" :disabled="!isView">
              <el-input v-model="item.defineName" size="mini" clearable filterable placeholder="堆箱名称" :disabled="isView" @blur="checkName"/>
            </el-tooltip>
          </el-col>

          <el-col :span="isView?7:6">
            <el-input v-model.number="item.row" size="mini" placeholder="行" style="width:50px" @blur="checkIsNumber(item.row, index,'row')" :disabled="isView || (item.brandList && item.brandList.length !==0)"/>
            <span style="padding: 0 5px">*</span>
            <el-input v-model.number="item.column" size="mini" placeholder="列" style="width:50px" @blur="checkIsNumber(item.column, index,'column')" :disabled="isView || (item.brandList && item.brandList.length !==0)"/>
          </el-col>
          <el-col :span="isView?9:8">
            <div v-if="item.brandList && item.brandList.length" :class="item.brandList && item.brandList.length < 15?'center':''" class="design-thumbnail" title="查看详情" @click="viewDesignDetail(findIndex(item.sequenceFlag), 'detail')">
                <div class="design-thumbnail-column" v-for="(cItem, cIndex) in item.brandList" :key="cIndex">
                  <div
                    class="design-thumbnail-row"
                    v-for="(rItem, rIndex) in getLine('row', index)"
                    :key="rIndex"
                    :style="`background:${cItem.tradeStackColor}`"
                  />
                </div>
            </div>
            <el-button v-else type="success" size="mini" plain @click="handleAddDesignDiagram(item, findIndex(item.sequenceFlag))">添加</el-button>
            <div
              v-show="!mixPackList[findIndex(item.sequenceFlag)].scopeDefineId && item.brandList.length"
              class="stack-design-modify"
              @click="viewDesignDetail(findIndex(item.sequenceFlag), 'detail')"
            >修改</div>
          </el-col>
          <el-col v-if="!isView" :span="5">
            <el-button  type="danger" size="mini" plain @click="handleDeleteRow(findIndex(item.sequenceFlag))">删除</el-button>
          </el-col>
          </div>
          <el-col class="checkBox" :span="24">
            <div class="checkBox-title">开放区域:</div>
            <div class="checkBox-main" v-if="isView">
              <div style="margin-right:20px;display: inline-block;" v-for="reginItem in item.regionList" :key="reginItem.orgCode">{{reginItem.orgName}}</div>
            </div>
            <div class="checkBox-main" v-else style="display:flex;align-items: center;">
              <el-checkbox
                  class="all color"
                  v-model="item.checkAll"
                  @change="handleCheckAllChange($event,index)"
                >{{item.checkAll?'全不选':'全选'}}</el-checkbox>
              <el-checkbox-group  v-model="item.regionCodeList" @change="handleCheckedCitiesChange($event,index)">
                <el-checkbox
                  v-for="regionItem in regionListByBu"
                  :label="regionItem.orgCode"
                  :key="regionItem.orgCode"
                  @change="cancelDialog(regionItem,index,item.scopeDefineId||'')">
                  {{regionItem.orgName}}{{getDefineCount(item.scopeDefineId, regionItem.orgCode)?'（' + getDefineCount(item.scopeDefineId, regionItem.orgCode) + '）':''}}
                 </el-checkbox>
              </el-checkbox-group>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="pagination">
        <el-pagination
          background
          :current-page.sync="pageInfo.currentPage"
          :page-size="pageInfo.pageSize"
          layout="total, prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>
    </div>

    <div v-else style="text-align:center">您暂未配置堆箱套餐</div>

    <StackConfigDialog ref="stackConfigDialog" :subBrandOptions="subBrandOptions" @confirm="onStackConfigConfirmed"/>
  </div>
</template>

<script>
import StackConfigDialog from './stack-config-dialog'
export default {
  components: {
    StackConfigDialog
  },
  props: {
    originThemeDefineDTO: {
      type: Object,
      default: () => {
        return {}
      }
    },
    primaryData: {
      type: Array,
      default: () => {
        return []
      }
    },
    status: {
      type: Number,
      default: () => {
        return 0
      }
    },
    regionListByBu: {
      type: Array,
      default: () => {
        return []
      }
    },
    defineCountMap: {
      type: Object,
      default: () => {
        return {}
      }
    },
    regionCancelConfirm: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      // 搜索
      formDesign: {
        defineName: '',
        rowColumn: '',
        stackPackSubBrands: ''
      },
      formSearch: {
        defineName: '',
        rowColumn: '',
        stackPackSubBrands: ''
      },
      // mixPackList: [
      //   {
      //     defineType: '01', // 定义类型，01-堆箱 03-必备品 04-组合陈列
      //     canUpdate: true,
      //     defineName: '堆箱1',
      //     stackPackSize: '',
      //     row: '',
      //     column: '',
      //     brandList: [],
      //     subBrandList: [],
      //     stackPackSubBrands: '',
      //     regionCodeList: [],
      //     regionCodes: '',
      //     checkAll: false,
      //     sequenceFlag: 1
      //   }
      // ],
      mixPackList: [],
      // 分页
      pageInfo: {
        currentPage: 1,
        pageSize: 5
      },
      total: 0,
      // 多选
      checkAll: false,
      regionCodeList: [],
      isIndeterminate: true,
      indexSelected: 0,
      sequenceFlag: 0 // 序号
    }
  },
  computed: {
    mixPackListPagination () {
      const filteredList = this.mixPackList.filter(item => {
        if (this.formSearch.defineName && item.defineName.toLowerCase().indexOf(this.formSearch.defineName.toLowerCase()) < 0) {
          return false
        }
        if (this.formSearch.rowColumn && (item.row + ' * ' + item.column) !== this.formSearch.rowColumn) {
          return false
        }
        if (this.formSearch.stackPackSubBrands) {
          if (!item.brandList) {
            return false
          }
          const brandArray = item.brandList.map(sItem => {
            return sItem.abiBrandCode
          }) || []
          if (brandArray.indexOf(this.formSearch.stackPackSubBrands) < 0) {
            return false
          }
        }
        return true
      })
      this.setTotal(filteredList.length)
      const startIndex = this.pageInfo.pageSize * (this.pageInfo.currentPage - 1)
      const endIndex = this.pageInfo.pageSize * this.pageInfo.currentPage
      return filteredList.slice(startIndex, endIndex)
    },
    sizeOptions () {
      let arr = []
      let mixPackList = this.autoSort(this.mixPackList)
      mixPackList.forEach(item => {
        if (item.row && item.column) {
          let rowColumn = item.row + ' * ' + item.column
          if (arr.indexOf(rowColumn)) {
            arr.push(rowColumn)
          }
        }
      })
      arr = [...new Set(arr)]
      return arr
    },
    subBrandOptions () {
      return this.originThemeDefineDTO.subBrandList || []
    },
    getDefineCount () {
      return (scopeDefineId, orgCode) => {
        let key = scopeDefineId + '_' + orgCode
        return this.defineCountMap[key]
      }
    },
    isView () {
      return this.$route.query.type === 'view'
    }
  },
  watch: {
    regionListByBu: {
      deep: true,
      immediate: true,
      handler () {
        this.mixPackList.forEach((item) => {
          if (item.regionList !== null && item.regionList.length === this.regionListByBu.length) {
            item.checkAll = true
          }
        })
      }
    }
  },
  methods: {
    // 设置基本信息
    setInfo () {
      this.mixPackList = this.primaryData
      this.mixPackList.forEach((item) => {
        if (item.sequenceFlag > this.sequenceFlag) {
          this.sequenceFlag = item.sequenceFlag
        }
        if (item.regionList) {
          item.regionList.forEach((region) => {
            region.orgName = region.orgName.substring(0, region.orgName.indexOf('|'))
          })
        }
        this.$set(item, 'row', parseInt(item.stackPackSize.split('*')[0]) || null)
        this.$set(item, 'column', parseInt(item.stackPackSize.split('*')[1]) || null)
        this.$set(item, 'checkAll', false)
        this.$set(item, 'regionCodeList', item.regionCodes ? item.regionCodes.split(',') : [])
      })
    },
    setTotal (total) {
      this.total = total
    },
    // 按照row进行排序
    autoSort (list) {
      // 深拷贝
      let arr = []
      list.forEach(item => {
        arr.push(item)
      })
      let sortList = arr.sort(function (a, b) {
        return a.row - b.row || a.column - b.column
      })
      return sortList
    },
    // 行列为整数
    checkIsNumber (value, index, type) {
      if (value !== parseInt(value) || value <= 0) {
        this.$message.warning('请输入大于0的整数')
        if (type === 'row') {
          this.mixPackListPagination[index].row = ''
        }
        if (type === 'column') {
          this.mixPackListPagination[index].column = ''
        }
      }
    },
    // 搜索
    onSubmit () {
      this.formSearch = JSON.parse(JSON.stringify(this.formDesign))
      this.pageInfo.currentPage = 1
    },
    // 重置
    handleResst () {
      this.formDesign = {
        defineName: '',
        rowColumn: '',
        stackPackSubBrands: ''
      }
      this.formSearch = {
        defineName: '',
        rowColumn: '',
        stackPackSubBrands: ''
      }
    },
    // 新增
    handleAddRow () {
      // this.mixPackListPagination.length
      if (!this.checkName()) {
        return
      }
      this.pageInfo.currentPage = 1
      this.sequenceFlag = 0
      this.mixPackList.forEach((item) => {
        if (item.sequenceFlag > this.sequenceFlag) {
          this.sequenceFlag = item.sequenceFlag
        }
      })
      this.formSearch = {}
      this.sequenceFlag++
      if (!this.mixPackList) {
        this.mixPackList = []
      }
      const cityOptions = this.regionListByBu.map(item => {
        return item.orgCode
      })
      this.mixPackList.unshift({
        defineType: '01', // 定义类型，01-堆箱 03-必备品 04-组合陈列
        canUpdate: true,
        defineName: '堆箱' + this.sequenceFlag,
        stackPackSize: '',
        row: '',
        column: '',
        brandList: [],
        regionCodeList: cityOptions,
        checkAll: true,
        sequenceFlag: this.sequenceFlag
      })
    },
    // 删除堆箱
    handleDeleteRow (index) {
      let message = '是否确认删除该堆箱类型'
      if (this.mixPackList[index].scopeDefineId && this.$route.query.status !== 0) {
        message = '若删除该任务，则选择该任务的活动都会被禁用！'
      }
      this.$confirm(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          if (this.mixPackList.length - 1 === index && index % 5 === 0 && this.pageInfo.currentPage > 1) {
            this.pageInfo.currentPage = this.pageInfo.currentPage - 1
          }
          this.mixPackList.splice(index, 1)
        })
        .catch(() => { })
    },
    // getIndex (index) {
    //   return (this.pageInfo.currentPage - 1) * this.pageInfo.pageSize + index
    // },
    findIndex (sequenceFlag) {
      let sIndex = 0
      this.mixPackList.forEach((item, index) => {
        if (item.sequenceFlag === sequenceFlag) {
          sIndex = index
        }
      })
      return sIndex
    },
    // 获取当前数据行/列数据
    getLine (type, index) {
      const sizeInfo = this.mixPackListPagination[index].stackPackSize
        ? this.mixPackListPagination[index].stackPackSize.split('*')
        : []
      if (type === 'row') {
        return Number(sizeInfo[0])
      }
      if (type === 'column') {
        return Number(sizeInfo[1])
      }
    },
    // 添加设计图
    handleAddDesignDiagram (item, index) {
      if (!this.checkName()) {
        return
      }
      if (!!item.row && !!item.column) {
        item.stackPackSize = item.row + '*' + item.column
      }
      if (!item.stackPackSize || !Number(item.row) || !Number(item.column)) {
        this.$message.warning('请正确填写堆箱规格')
        return
      }
      this.indexSelected = index
      const data = {
        stackData: item,
        brandSelected: []
      }
      const options = {
        indexSelected: index,
        showMode: 'edit'
      }
      this.$refs.stackConfigDialog.show(data, options)
    },
    onStackConfigConfirmed (payload) {
      const stackData = payload.stackData
      const brandSelected = payload.brandSelected || []
      const indexSelected = payload.options.indexSelected
      if (!this.checkSame(stackData, brandSelected, indexSelected)) {
        return
      }
      // 添加
      this.mixPackList[indexSelected].brandList = []
      brandSelected.forEach(item => {
        let brandInfo = item ? item.split(',') : []
        this.mixPackList[indexSelected].brandList.push({
          abiBrandCode: brandInfo[0],
          brandName: brandInfo[1],
          tradeStackColor: brandInfo[2]
        })
      })
      this.mixPackList[indexSelected].row = stackData.row
      this.mixPackList[indexSelected].column = stackData.column
      this.mixPackList[indexSelected].stackPackSize = stackData.row + '*' + stackData.column
      this.$refs.stackConfigDialog.close()
    },
    // 查看堆箱设计图
    viewDesignDetail (index) {
      const brandSelected = []
      this.mixPackList[index].brandList.forEach(item => {
        brandSelected.push(item.abiBrandCode + ',' + item.brandName + ',' + item.tradeStackColor)
      })
      const data = {
        stackData: this.mixPackList[index],
        brandSelected: brandSelected
      }
      const showMode = this.mixPackList[index].scopeDefineId ? 'view' : 'edit'
      const options = {
        indexSelected: index,
        showMode: showMode
      }
      this.indexSelected = index
      this.$refs.stackConfigDialog.show(data, options)
    },
    // 检查堆箱名称
    checkName (e) {
      if (e && !e.target.value) {
        this.$message.warning('堆箱设计配置名称不能为空')
        return
      }
      let nameArr = []
      if (this.mixPackList.length) {
        this.mixPackList.forEach(item => {
          nameArr.push(item.defineName)
        })
      }

      if (!this.sortCheckSame(nameArr)) {
        this.$message.warning('堆箱设计配置名称重复')
        return false
      }
      return true
    },
    // 校验套餐重复
    checkSame (stackData, brandSelected, indexSelected) {
      let checkedResult = true
      const nowName = stackData.defineName
      const nowSize = stackData.row + '*' + stackData.column
      let nowBrandStr = ''

      // 组装当前操作套餐所选的品牌编码字符串
      if (brandSelected.length) {
        let arr = []
        brandSelected.forEach(item => {
          arr.push(item.split(',')[0])
        })
        nowBrandStr = arr.length ? arr.sort().join(',') : ''
      }

      // 组装并比较所有列表里相同规格的套餐品牌
      for (let i = 0; i < this.mixPackList.length; i++) {
        if (i === indexSelected) {
          continue
        }
        let itemBrandStr = ''
        let item = this.mixPackList[i]
        // 规格相同 名字不是当前套餐 已配置混堆设计
        if (
          item.stackPackSize === nowSize &&
          item.defineName !== nowName && item.brandList.length
          // (item.brandList && item.brandList.length)
        ) {
          let itemBrandArr = []
          item.brandList.forEach(brandInfo => {
            itemBrandArr.push(brandInfo.abiBrandCode)
          })
          itemBrandStr = itemBrandArr.length
            ? itemBrandArr.sort().join(',')
            : ''
        }
        if (nowBrandStr === itemBrandStr) {
          this.$message.warning(`当前设计与套餐 "${item.defineName}" 重复`)
          checkedResult = false
          break
        }
      }
      return checkedResult
    },
    // 排序查重
    sortCheckSame (checkArr) {
      let arr = Object.assign([], checkArr)
      let checkedResult = true

      if (arr.length) {
        let sortArr = arr.sort()
        for (let i = 0; i < sortArr.length; i++) {
          if (sortArr[i] === sortArr[i + 1]) {
            checkedResult = false
            break
          }
        }
      }
      return checkedResult
    },
    // 多选
    handleCheckAllChange (val, index) {
      const cityOptions = this.regionListByBu.map(item => {
        return item.orgCode
      })
      if (val) {
        this.mixPackListPagination[index].regionCodeList = cityOptions
        return
      }
      if (this.regionCancelConfirm) {
        this.mixPackListPagination[index].checkAll = true
        this.$confirm('若取消该区域，则该区域选择了此任务的活动都会被禁用！', '是否取消开放该区域', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          this.mixPackListPagination[index].regionCodeList = []
          this.mixPackListPagination[index].checkAll = false
        }).catch(() => {
          this.mixPackListPagination[index].regionCodeList = cityOptions
          this.mixPackListPagination[index].checkAll = true
        })
      } else {
        this.mixPackListPagination[index].regionCodeList = []
      }
    },
    // 多选
    handleCheckedCitiesChange (value, index) {
      let arr = this.regionListByBu.filter((item, index) => {
        let flag = false
        value.forEach((sItem, sIndex) => {
          if (item.orgCode === sItem) {
            flag = true
          }
        })
        return flag
      })
      this.mixPackListPagination[index].regionCodeList = arr.map((item, index) => item.orgCode)
      let checkedCount = value.length
      this.mixPackListPagination[index].checkAll = checkedCount === this.regionListByBu.length
      this.mixPackListPagination[index].isIndeterminate = checkedCount > 0 && checkedCount < this.regionListByBu.length
    },
    // region单选取消弹窗
    cancelDialog (item, index, scopeDefineId) {
      let message = ''
      let key = scopeDefineId + '_' + item.orgCode
      if (this.defineCountMap[key] !== undefined) {
        message = '此任务已被该区域的' + this.defineCountMap[key] + '个活动引用，'
      }
      if (this.mixPackListPagination[index].regionCodeList.indexOf(item.orgCode) === -1 && this.regionCancelConfirm) {
        this.$confirm(message + '若取消区域，则区域选择了此任务的活动都会被禁用！', '是否取消开放该区域', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          // this.$message.success('已取消')
        }).catch(() => {
          this.mixPackListPagination[index].regionCodeList.push(item.orgCode)
        })
      }
    },
    // 组合数据
    getMixinPackInfo () {
      let params = this.mixPackList.map(item => {
        let stackPackSubBrands = item.brandList.map(sItem => {
          return sItem.abiBrandCode
        }).join(',')
        return {
          scopeDefineId: item.scopeDefineId,
          defineType: '02',
          defineName: item.defineName,
          stackPackSize: item.stackPackSize,
          regionCodes: item.regionCodeList.join(','),
          stackPackSubBrands: stackPackSubBrands,
          sequenceFlag: item.sequenceFlag
        }
      })
      return params
    },
    checkData (status) {
      // status 0=保存，1=提交
      let checkedResult = true
      // 每个套餐内容都不会为空 则通过校验
      // 校验混堆名字重复
      checkedResult = this.checkName()
      if (!checkedResult) {
        return false
      }
      // 每个套餐内容都不会为空
      if (this.mixPackList.length) {
        this.mixPackList.forEach(item => {
          if (!item.row || !item.column || !item.brandList.length || !item.defineName) {
            checkedResult = false
          }
          // if (status) {
          //   checkedResult = checkedResult && item.regionCodeList.length
          // }
          if (!checkedResult) {
            this.$message.warning({
              message: '请正确配置“堆箱设计配置”部分数据',
              duration: 8000
            })
            checkedResult = false
          }
        })
      }
      return checkedResult
    }
  }
}
</script>

<style lang="scss" scoped>
.require {
  position: relative;
  &::before {
    content: '*';
    font-size: 20px;
    width: 5px;
    height: 5px;
    color: red;
    position: absolute;
    top: -10px;
    left: -10px;
  }
}
.iptSize {
  margin-right: 10px;
}
.wrapper {
  ::v-deep .el-button {
    padding: 7px 20px;
  }

  // ::v-deep .el-input__icon {
  //   height: 40px;
  // }
  position: relative;
  background-color: #fff;
  // height: 800px;
  .content {
    display: flex;
    justify-content: flex-start;
    line-height: 50px;
    color: #333;
    transition: height 0.5s;
    .title {
      display: flex;
      flex: none;
      width: 100%;
      // flex-basis: 14%;
      font-size: 16px;
      font-weight: 600;
      justify-content: space-between;
      div {
        // width: 100%;
        text-align: right;
      }
      .el-button {
        display: inline-block;
      }
    }
  }
  .info {
    position: relative;
    // min-height: 700px;
    .header {
      line-height: 40px;
      border-radius: 5px;
      background: #eee;
    }
    .el-col {
      text-align: center;
    }
    .detail {
      min-height: 90px;
      border-bottom: 1px solid #ccc;
      padding: 10px 0;
      .center {
        justify-content: center;
      }
      .design-thumbnail {
        display: flex;
        // justify-content: center;
        white-space: nowrap;
        overflow-x: auto;
        width: 100%;
        height: 100%;
        cursor: pointer;
        .design-thumbnail-column {
          display: inline-block;
        }
        .design-thumbnail-row {
          box-sizing: border-box;
          width: 25px;
          height: 25px;
          border: 1px solid #c0c4cc;
          border-radius: 3px;
        }
      }
      .design {
        text-align: center;
        .design-img {
          display: flex;
          flex-wrap: wrap;
          height: 100px;
          width: 100px;
          margin: 0 auto;
          // border: 1px solid #C0C4CC;
          border-radius: 8px;
          div {
            box-sizing: border-box;
            display: inline-block;
            border: 1px solid #c0c4cc;
            border-radius: 3px;
          }
        }
      }
      .region-wrapper {
        line-height: 30px;
        text-align: left;
        padding: 10px 0;
      }
    }
  }
  .card-wraper {
    // position: absolute;
    width: 100%;
    height: calc(100% + 120px);
    top: -60px;
    right: 0;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2;
  }
  .box-card {
    // width: 700px;
    pointer-events: auto;
    z-index: 2;
    .card-header {
      text-align: center;
      line-height: 40px;
      font-size: 18px;
      font-weight: 600;
      color: #333;
      span {
        display: inline-block;
        width: 50%;
      }
    }
    .card-shortcut {
      display: flex;
      align-items: center;
      .shortcut-title {
        width: 110px;
        margin: 20px 10px 20px 20px;
      }
      // .shortcut-main {
      //   margin: 0 auto
      // }
    }
    .card-select {
      display: flex;
      flex-wrap: nowrap;
      overflow-x: scroll;
      max-height: 500px;
      max-width: 600px;
      padding-bottom: 20px;
      margin-top: 20px;
      min-width: 350px;
    }
    .card-box {
      margin: auto;
    }
  }
  .card-item {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: 100px;
    height: 80px;
    margin: 10px auto 0;
    line-height: initial;
    text-align: center;
    color: #fff;
    border: 1px solid #c0c4cc;
    border-radius: 10px;
  }
  .card-operte {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
  }
  .pagination {
    text-align: center;
    padding: 20px 0;
  }
}
.el-select {
  width: 120px;
}
// 开放区域
.checkBox {
  margin-top: 10px;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #606266;
  .checkBox-title{
    flex-basis: 7%;
  }
  .checkBox-main{
   flex-basis: 78%;
  }
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #409eff;
  border-color: #409eff;
}
::v-deep .el-checkbox__inner:hover {
  background-color: #409eff;
  border-color: #409eff;
}
::v-deep .isfocus {
  color: #409eff;
}
.all {
  padding: 0 20px 0 10px;
}
::v-deep .all .el-checkbox__inner {
  display: none;
}
::v-deep .el-checkbox__label {
  padding-left: 5px;
}
.color {
  color: #409eff !important;
}
.wrapper .info .checkBox {
  text-align: left;
  padding-left: 100px;
}
::v-deep .el-dialog__header {
  border:none ;
  padding: 0;
}
.stack-design-modify {
  font-size: 14px;
  padding: 5px 10px;
  cursor: pointer;
  color: red;
  line-height: 30px;
}
</style>
